module.exports = __webpack_public_path__ + "static/CFG_PO_FinalistsBanner_GIdotORG-5caa8c4911f7ca80274c05f3d1de581e.jpg";